// tslint:disable:variable-name

import {XauditModel} from '../../../../models/xaudit.model';

export class ReferringDoctorDataModel extends XauditModel {
  RefDoctorID = '';
  Provider_DoctorID = '';
  FullName = '';
  email = '';
  phone = '';
}


/*export class ReferralScheduleDataModel extends XauditModel {
  ReferralScheduleItemID: string;
  DoctorId: string;
  iOrder: number;
  ItemName: string;
  ItemDescription: string;
  ItemParameter: string;
}*/

